import React from "react";
export default function Footer(){
		return (
			<footer>
                <ul>
                        <li data-title="Finder"><img data-title="Finder" src="https://harnerdesigns.com/wp-content/uploads/2018/05/finder.png"/></li>
                        <li data-title="Chrome"><img src="https://harnerdesigns.com/wp-content/uploads/2018/05/Google_Chrome_icon_2011.png"/></li>
                        <li data-title="iTunes" class="closed" id="iTunes"><img src="https://harnerdesigns.com/wp-content/uploads/2018/05/iTunes-logo.svg"/></li>
                        <li data-title="Photoshop"><img src="https://harnerdesigns.com/wp-content/uploads/2018/05/Adobe_Photoshop_CS6_icon.png"/></li>
                        <li data-title="Dreamweaver"><img src="https://harnerdesigns.com/wp-content/uploads/2018/05/Adobe_Dreamweaver_CS6_Icon.png"/></li>
                        <li data-title="System&nbsp;Preferences"><img src="https://harnerdesigns.com/wp-content/uploads/2018/05/20140418_System_Preferences.png"/></li>
                        <li data-title="Trash"><img src="https://harnerdesigns.com/wp-content/uploads/2018/05/512-TrashIcon-macosx1.png"/></li>
                </ul>
            </footer>
		);
}
